import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface ReviewType {
  label: string
  value: PerformanceReviewerStrategiesStrategyEnum
  description: string
  disabled: boolean
}

export const reviewTypeOptions = (): ReviewType[] => [
  {
    label: i18n.t('performance_process.reviews.review_type_self'),
    description: i18n.t('performance_process.reviews.review_type_self_description'),
    value: 'self',
    disabled: false,
  },
  {
    label: i18n.t('performance_process.reviews.review_type_manager'),
    description: i18n.t('performance_process.reviews.review_type_manager_description'),
    value: 'manager',
    disabled: false,
  },
  {
    label: i18n.t('performance_process.reviews.review_type_direct'),
    description: i18n.t('performance_process.reviews.review_type_direct_description'),
    value: 'direct_reports',
    disabled: false,
  },
  {
    label: i18n.t('performance_process.reviews.review_type_peer'),
    description: i18n.t('performance_process.reviews.review_type_peer_description'),
    value: 'peers',
    disabled: false,
  },
]
